/*
  Benefits accordion
  1) Marquee speed: each column is measured and given its own animation-duration
     from a shared px/s speed, so both columns move at the same visual speed even
     when they hold a different number of images.
  2) Accordion: rows are native <details> (they open/close with no JS at all).
     This animates the panel height with one shared duration for open AND close,
     plus the optional "one open at a time" behaviour.

  COREEX Focal port: carried over from dev-coreex-theme unchanged. This file has
  no Dawn dependency -- it keys off the .benefits-accordion class names and the
  data-* attributes on the section root, all of which the Focal markup keeps.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Marquee ---------- */

  function syncColumn(col, pxPerSec) {
    var track = col.querySelector('.benefits-accordion__track');
    var group = col.querySelector('.benefits-accordion__group');
    if (!track || !group) return;

    // the animation travels exactly one group (-50% of the track)
    var distance = group.offsetHeight;
    if (!distance) return;

    var duration = distance / pxPerSec;
    track.style.animationDuration = duration + 's';
  }

  function syncMarquee(section) {
    var speed = parseFloat(section.getAttribute('data-speed')) || 30;
    var cols = section.querySelectorAll('.benefits-accordion__col');
    for (var i = 0; i < cols.length; i++) syncColumn(cols[i], speed);
  }

  /* ---------- Accordion ---------- */

  function setupAccordion(section) {
    var single = section.getAttribute('data-single-open') === 'true';
    var ms = (parseFloat(section.getAttribute('data-panel-speed')) || 0.3) * 1000;
    var items = section.querySelectorAll('.benefits-accordion__item');

    function closeItem(item, animate) {
      var panel = item.querySelector('.benefits-accordion__panel');
      if (!panel || !item.open) return;

      if (!animate || reduced.matches) {
        item.open = false;
        return;
      }

      item.classList.add('is-closing');
      var from = panel.offsetHeight;
      var anim = panel.animate([{ height: from + 'px' }, { height: '0px' }], {
        duration: ms,
        easing: 'ease',
      });
      item.__anim = anim;
      anim.onfinish = function () {
        item.open = false;
        item.classList.remove('is-closing');
        panel.style.height = '';
        item.__anim = null;
      };
    }

    function openItem(item) {
      var panel = item.querySelector('.benefits-accordion__panel');
      var inner = item.querySelector('.benefits-accordion__panel-inner');
      if (!panel || !inner) {
        item.open = true;
        return;
      }

      item.open = true;

      if (reduced.matches) return;

      var to = inner.offsetHeight;
      var anim = panel.animate([{ height: '0px' }, { height: to + 'px' }], {
        duration: ms,
        easing: 'ease',
      });
      item.__anim = anim;
      anim.onfinish = function () {
        panel.style.height = '';
        item.__anim = null;
      };
    }

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var summary = item.querySelector('.benefits-accordion__summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          // take over from the browser so open AND close can both animate
          e.preventDefault();

          if (item.__anim) item.__anim.cancel();

          if (item.open) {
            closeItem(item, true);
            return;
          }

          if (single) {
            for (var j = 0; j < items.length; j++) {
              if (items[j] !== item) {
                if (items[j].__anim) items[j].__anim.cancel();
                closeItem(items[j], true);
              }
            }
          }

          openItem(item);
        });
      })(items[i]);
    }
  }

  /* ---------- Boot ---------- */

  function initSection(section) {
    if (!section || section.__baInit) return;
    section.__baInit = true;

    setupAccordion(section);
    syncMarquee(section);

    // images change the track height once they load
    var imgs = section.querySelectorAll('.benefits-accordion__img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) {
        imgs[i].addEventListener('load', function () {
          syncMarquee(section);
        });
      }
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncMarquee(section);
      });
    }

    var t;
    section.__baResize = function () {
      clearTimeout(t);
      t = setTimeout(function () {
        syncMarquee(section);
      }, 150);
    };
    window.addEventListener('resize', section.__baResize);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.benefits-accordion');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.benefits-accordion');
    if (r) {
      r.__baInit = false;
      initSection(r);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('.benefits-accordion');
    if (r && r.__baResize) window.removeEventListener('resize', r.__baResize);
  });
})();
